<template>
    <div class="col-12 offset-1">
      <div class="card mb-5 me-4" style="margin-top: 4rem; overflow: visible">
        <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
          <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">تعديل بيانات الرابط</h6>
            </div>
          </div>
        </div>
      <LoadingSpinner v-if="isLoading" message="جاري تحميل بيانات الرابط..." />
      <ChapterSubjectForm
        v-else-if="chapterSubject"
        :initial-data="chapterSubject"
        :is-loading="isUpdating"
        :is-edit-mode="true"
        submit-text="حفظ التعديلات"
        @submit="updateChapterSubject"
        @cancel="navigateBack"
      />
    </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from "vue";
  import { useRouter, useRoute } from "vue-router";
  import { useToast } from 'vue-toastification';
  import ChapterSubjectForm from "@/components/features/chapter-subject/ChapterSubjectForm.vue";
  import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
  import api from "@/api"; 
  
  const router = useRouter();
  const route = useRoute();
  const toast = useToast();
  
  const isLoading = ref(false);
  const isUpdating = ref(false);
  const chapterSubject = ref(null);
  
  const fetchChapterSubject = async () => {
    isLoading.value = true;
    try {
      const response = await api.get(`/chapter-subjects/${route.params.id}`, {
        params: { with: 'chapter,subject' }
      });
      chapterSubject.value = response.data.data;
    } catch (error) {
      toast.error("فشل في تحميل بيانات الرابط");
      console.error("Error fetching chapter subject:", error);
      router.push({ name: 'chapter-subjects.index' });
    } finally {
      isLoading.value = false;
    }
  };
  
  const updateChapterSubject = async (formData) => {
    isUpdating.value = true;
    try {
      await api.put(`/chapter-subjects/${route.params.id}`, formData);
      toast.success("تم تحديث بيانات الرابط بنجاح");
      router.push({ name: 'chapter-subjects.index' });
    } catch (error) {
      if (error.response?.status === 422) {
        toast.error("الرجاء تصحيح الأخطاء في النموذج");
      } else {
        toast.error(error.response?.data?.message || "فشل في تحديث البيانات");
      }
      console.error("Error updating chapter subject:", error);
    } finally {
      isUpdating.value = false;
    }
  };
  
  const navigateBack = () => {
    router.push({ name: 'chapter-subjects.index' });
  };
  
  onMounted(() => fetchChapterSubject());
  </script>